import { FC, useState, useEffect } from 'react'
import { Popover } from 'antd'
import styles from './index.module.scss'
import { Link } from 'react-router-dom'
import { NoSSR } from '@utils/SSR'
import { useSelector } from 'react-redux'
import type { RootState } from '@api/home/store'
import { Switch } from '@ui-pc'
import WaterLayout from './WaterLayout'

// 使用dangerouslySetInnerHTML得接受字符串渲染
const renderMenu = (item: any) => {
  return item.navIcon != ''
    ? `<span style="padding-top: 0px;padding-bottom:0px">
    <img src=${item.navIcon} alt="" style="max-height: 40px" />
  </span>`
    : `<span>${item.navTitle}</span>`
}

const MenuPopover = ({ data, setShowMask }) => {
  const [popoverVisible, setPopoverVisible] = useState(false)
  const imgList = data.defaultImg.slice(0, 2)
  const handleChange = (open: boolean) => {
    setPopoverVisible(open)
    setShowMask(open)
  }
  const hidePopover = () => {
    setPopoverVisible(false)
    setShowMask(false)
  }

  const [items, setItems] = useState([])

  // 渲染节点
  const renderMenuChild = () => {
    const newItems = items.slice()
    data.child?.map((second: any) => {
      const div = (
        <div
          key={second.id}
          className={`${styles['second']} ${styles['water-item']}`}>
          <Link
            to={second.url}
            className={styles['second-item-link']}
            onClick={hidePopover}
            target={second.isTarget === '1' ? '_blank' : '_self'}
            style={{ color: second.navColor }}
            dangerouslySetInnerHTML={{
              __html: renderMenu(second)
            }}></Link>
          {second.child.length > 0 && (
            <div>
              {second.child.map((three) => (
                <Link
                  key={three.id}
                  to={three.url}
                  className={styles['three-item-link']}
                  onClick={hidePopover}
                  target={three.isTarget === '1' ? '_blank' : '_self'}
                  style={{ color: three.navColor }}
                  dangerouslySetInnerHTML={{
                    __html: renderMenu(three)
                  }}></Link>
              ))}
            </div>
          )}
        </div>
      )
      newItems.push(div)
    })
    setItems(newItems)
  }
  useEffect(() => {
    renderMenuChild()
  }, [data.child])

  return (
    <Popover
      destroyTooltipOnHide={true} // 必须销毁，因为要动态执行瀑布流
      open={popoverVisible}
      overlayClassName={styles['menu-overlay']}
      placement="bottom"
      content={
        <div className={styles['dropdown']}>
          <div
            className={`${styles['left']} ${
              styles[`has-image-${imgList.length}`]
            }`}>
            <Switch either={imgList.length}>
              {/* 瀑布流: 有图片才执行 */}
              <WaterLayout itemsNode={items} />
              {/* flex */}
              <div className={`${styles['nav-flex-container']}`}>{items}</div>
            </Switch>
          </div>
          {imgList.length > 0 && (
            <div
              className={`${styles['right']} ${
                styles[`has-image-${imgList.length}`]
              }`}>
              {imgList.map((item) => (
                <Link
                  key={item.navImg}
                  to={item.imgLink}
                  className={styles['right-link']}
                  onClick={hidePopover}
                  style={{ color: item.navColor }}>
                  <div className={styles['right-img-box']}>
                    <img src={item.navImg} alt="" />
                  </div>
                  {item.imgText && (
                    <div className={styles['right-img-text']}>
                      <p>{item.imgText} </p>
                      <i className="iconfont icon-m_ic_jiantou"></i>
                    </div>
                  )}
                </Link>
              ))}
            </div>
          )}
        </div>
      }
      getPopupContainer={(trigger) => trigger.parentElement}
      trigger="hover"
      onOpenChange={handleChange}
      arrow={false}>
      <Link
        className={`${styles['menu-item-link']}`}
        to={data.url}
        target={data.isTarget === '1' ? '_blank' : '_self'}
        onClick={hidePopover}
        style={{ color: data.navColor }}
        dangerouslySetInnerHTML={{
          __html: renderMenu(data)
        }}></Link>
    </Popover>
  )
}

interface InavigationMenuProps {}

const NavigationMenu: FC<InavigationMenuProps> = (props) => {
  const menu = useSelector((state: RootState) => state.app.menu)
  // const {
  //   data: pageData,
  //   isLoading,
  //   isError
  // } = useSearch(() => getNavigationMenu({}))
  // const nav = pageData?.nav

  const [showMask, setShowMask] = useState(false)

  return (
    <nav className={styles['header-nav-wrap']} id="navWrap">
      <div className="global-section-inner">
        <NoSSR>
          <ul className={styles['menu']}>
            {Array.isArray(menu) &&
              menu.map((item) => (
                <li key={item.id} className={styles['menu-item']}>
                  {item.child.length > 0 ? (
                    <MenuPopover
                      data={item}
                      setShowMask={setShowMask}></MenuPopover>
                  ) : (
                    <Link
                      className={`${styles['menu-item-link']}`}
                      to={item.url}
                      target={item.isTarget === '1' ? '_blank' : '_self'}
                      style={{ color: item.navColor }}
                      dangerouslySetInnerHTML={{
                        __html: renderMenu(item)
                      }}></Link>
                  )}
                </li>
              ))}
          </ul>
          {showMask && <div className={styles['popver-mask']}></div>}
        </NoSSR>
      </div>
    </nav>
  )
}

export default NavigationMenu
